<h3>
  Pojawiło się nowe zamówienie numer {{ details.number }} na kwotę:
  {{ details.amount | currency: details.currency }}
</h3>
@if (details.isTest) {
  <div class="test">TEST</div>
}
@if (details.context==='PrivateSession') {
  <p>Sesja
    <lib-quick-link
      [contextId]="details.contextId"
      [context]="'PrivateSession'"
    ></lib-quick-link>
    dla
  {{ ob | objectLabel: details.organizationClientId | async }}</p>
  <div class="images">
    @if (details?.images) {
      @for (photo of avisibleImages$ | async; track photo; let i = $index) {
        <lib-image-loader
          (click)="showImages(i)"
          [isCover]="true"
        [url]="
        {
          photoId: photo.photoId
        }
          | getImageUrl
            : photo.photoGroupId
            : 'photographer'
            : privateSessionContext
            : details.contextId
            : 200
          | async
      "
      ></lib-image-loader>
    }
  }
  @if ((contextImages$ | async)?.length>9) {
    <div
      (click)="showImages(8)"
      class="more"><span>{{(contextImages$ | async)?.length - (avisibleImages$ | async)?.length}}</span></div>
    }
  </div>
}
<div class="footer">
  <lib-button (click)="preview()">pokaż zamówienie</lib-button>
</div>
